import io from 'socket.io-client';
import { eventChannel } from 'redux-saga';
import { websocketUrl } from 'util/config';

// Configurations for websocket connections
const socketsPort = ':3001';
const socketsConfig = {
  transports: ['websocket'],
  forceNew: true,
  query: {},
};

/**
 * Class handles websocket connections and subscriptions
 */
export default class SocketService {
  static socket;
  static instance;

  // Opens new websocket connection
  static createConnection() {
    return io(websocketUrl + socketsPort, socketsConfig);
  }

  // Returns socket service instance, or create it if it's empty
  static get Instance() {
    if (!SocketService.instance) {
      SocketService.instance = new SocketService();
    }
    return SocketService.instance;
  }

  /**
   * Creates or updates a socket connection
   * @param userId number Id of a current user to add him to the online users list
   */
  reconnect(userId = null, companyId = null) {
    if (userId && companyId) {
      socketsConfig.query['user-id'] = userId;
      socketsConfig.query['company-id'] = companyId;
      socketsConfig.query['domain'] = window.location.hostname;
    }

    if (!SocketService.socket || !SocketService.socket.connected) {
      SocketService.socket = SocketService.createConnection();
    }
  }

  // Disconnects socket
  disconnect() {
    if (SocketService.socket) {
      SocketService.socket.close();
    }
  }

  // Subscribes socket to the specified event
  onSubscribe(eventName) {
    return eventChannel((emit) => {
      const handler = (data) => {
        if (!data) {
          return;
        }

        emit(data);
      };
      SocketService.socket.on(eventName, handler);

      return () => SocketService.socket.off(eventName, handler);
    });
  }

  // Unsubscribes socket from the specified event
  onUnsubscribe(eventName) {
    if (SocketService.socket) {
      SocketService.socket.off(eventName);
    }
  }
}
